import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { GetPictureUploadUrlDto } from "@/dtos/get-picture-upload-url.dto";
import { ref, Ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import { useShowWarningMessage } from "@/composables/use-notifications";
import axios from "axios";
import store from "@/store";
import { Loading } from "element-ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'change-profile-picture-dialog',
  props: {
    isVisible: { type: Boolean },
    profilePicture: null,
    onClose: null,
    onRefresh: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  profilePicture?: string;
  onClose: () => void;
  onRefresh: () => void;
}



const uploading = ref(false);
const selectedFile: Ref<any | null> = ref();
const studentProfilePicture = ref("");
const uploadingProgress = ref(0);
const fileKey = ref("");

const clearFields = () => {
  selectedFile.value = null;
  uploadingProgress.value = 0;
  studentProfilePicture.value = "";
};

const onDialogClose = () => {
  props.onClose();
  clearFields();
};

const onOpen = () => {
  if (props.profilePicture) {
    studentProfilePicture.value = props.profilePicture;
  }
};

const onPhotoInputClick = (e: any) => {
  e.target.value = "";
};

const onSelectPhotoChange = (e: any) => {
  e.preventDefault();
  const ALLOWED_FILE_EXTENSIONS = ["png", "jpg", "jpeg"];

  // Ensure the file type chosen is an image in the allowed file extensions
  selectedFile.value = e.target.files[0];
  const fileExtension = selectedFile.value.name
    ?.split(".")
    ?.pop()
    ?.toLowerCase();
  if (!ALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
    return useShowWarningMessage(
      "Invalid file-Type",
      `Only images of type ${ALLOWED_FILE_EXTENSIONS.toString()} are allowed`
    );
  }
  // Otherwise set the image url to show on the UI
  studentProfilePicture.value = URL.createObjectURL(selectedFile.value);
};

const handleRemove = () => {
  studentProfilePicture.value = "";
  selectedFile.value = null;
};

const requestFileUploadUrl = async () => {
  const request = await useHttpRequest<GetPictureUploadUrlDto>({
    method: "POST",
    url: `students/get-profile-picture-upload-url/${store.state.userId}`,
    loadingProperty: uploading,
    showSuccessMessage: false,
    body: {
      file_name: selectedFile.value.name,
      file_size: selectedFile.value.size,
      mime_type: selectedFile.value.type,
    },
  });

  if (!request) return;
  if (request.success && request.message == "S3_UPLOAD_URL_GENERATED") {
    // aws_upload_url.value = request.aws_upload_url;
    // uploadResourceToAWS(aws_upload_url.value, selectedFile.value.raw, fileKey)
    fileKey.value = request.file_key;
    return request.aws_upload_url;
  }
};

const uploadResourceToAWS = async () => {
  try {
    const awsUploadUrl = await requestFileUploadUrl();

    if (!awsUploadUrl) {
      return useShowWarningMessage(
        "Error",
        "An error occurred while uploading file"
      );
    }

    const formData = new FormData();
    Object.entries(awsUploadUrl.fields).forEach(([key, value]) => {
      //@ts-ignore
      formData.append(key, value);
    });
    formData.append("file", selectedFile.value);

    // send the file to the aws server
    const response = await axios.post(`${awsUploadUrl.url}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: " ",
      },
      onUploadProgress: (progressEvent) => {
        const loader = document.querySelector(
          ".el-loading-text"
        ) as HTMLElement;
        const progress = +(
          (progressEvent.loaded / progressEvent.total) *
          100
        ).toFixed(0);

        loader.innerText = `Uploading... ${progress}%`;
      },
    });

    if (response.status == 204) {
      return response.headers.location;
    } else {
      throw "UNEXPECTED_RESPONSE";
    }
  } catch (error: any) {
    if (error.message == "Network Error") {
      useShowWarningMessage(
        "Connection failed",
        "A network error occurred, please try again."
      );
    }
    useShowWarningMessage(
      "Upload Failed",
      // "Unable to Upload Resource Now, please try again"
      error.message
    );
  }
};

const addProfilePicture = async () => {
  let loadingIndicator;
  try {
    if (selectedFile.value == null) {
      if (studentProfilePicture.value) {
        //Just close the dialog
        return onDialogClose();
      }
      return useShowWarningMessage("Empty", "Profile picture is empty");
    }

    loadingIndicator = Loading.service({
      lock: true,
      text: "Uploading Files...",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const pathUrl = await uploadResourceToAWS();

    const request = await useHttpRequest<{ success: boolean; message: string }>(
      {
        method: "PATCH",
        url: `students/on-profile-picture-aws-uploaded/${store.state.userId}`,
        loadingProperty: null,
        showSuccessMessage: true,
        body: {
          path_url: pathUrl,
          file_key: fileKey.value,
        },
      }
    );

    if (!request) return;
    if (request.success && request.message == "Photo updated successfully") {
      onDialogClose();
      props.onRefresh();
    }
  } catch (error) {
    console.error(error);
    useShowWarningMessage("Error", "An error occurred while uploading files");
  } finally {
    if (loadingIndicator) {
      loadingIndicator.close();
    }
  }
};

return { __sfc: true,props, uploading, selectedFile, studentProfilePicture, uploadingProgress, fileKey, clearFields, onDialogClose, onOpen, onPhotoInputClick, onSelectPhotoChange, handleRemove, requestFileUploadUrl, uploadResourceToAWS, addProfilePicture, BaseDialog }
}

})